// extracted by mini-css-extract-plugin
module.exports = {"projectWorkspaceHeader":"ProjectWorkspace_projectWorkspaceHeader__1vyMW","projectWorkspaceContent":"ProjectWorkspace_projectWorkspaceContent__29GVh"};